import React, { useState } from 'react'
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { usePacientePruebaAlergia } from './hooks/usePacientePruebaAlergia';
import { Empty, Error, Forbidden, IconButton, Loader, ModalContainer } from '../../components';

import styles from './PacientePruebasAlergia.module.css';
import { colors } from '../../types/types';
import { DetallePruebaAlergiaModal } from '../Modals/DetallePruebaAlergia';

export const PacientePruebasAlergia = () => {

  let { id } = useParams();

  const { permisos } = useSelector(state => state.auth);

  const { pacientePruebaAlergiaQuery: { isLoading, isFetching, isError, data: pruebasAlergia } } = usePacientePruebaAlergia(id);
  
  const [pruebaAlergiaActiva, setPruebaAlergiaActiva] = useState(null);
  
  const [statusDetallesModal, setStatusDetallesModal] = useState(false);

  const showDetallesModal = () => {
    setStatusDetallesModal(true);
  }

  const hideDetallesModal = () => {
    setStatusDetallesModal(false);
  }

  const handleDetalles = (prueba) => {
    setPruebaAlergiaActiva(prueba);
    showDetallesModal();
  }

  return (permisos.pruebaAlergiaRead) ? (
    <>
    {(isLoading || isFetching)
      ? <Loader />
      : <>
          {(isError)
            ? <Error />
            : <>
              {(pruebasAlergia.length > 0)
                ? <>
                  <div className={styles.panelSection + " " + styles.panelNoHeader}>
                    <div className="row">
                      <div className="col-sm-12 col-md-6">
                        <div className={styles.tableHeader}>Historial de pruebas de alergia</div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="table-responsive">
                        <table className="table align-middle">
                          <thead>
                            <tr>
                              <th scope="col">Fecha</th>
                              <th scope="col">Tipo</th>
                              <th scope="col">Prueba</th>
                              <th scope="col">Alergenos</th>
                              <th scope="col">Resultados</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody className="table-group-divider">
                          {pruebasAlergia.map(prueba => <tr key={ prueba._id } onClick={() => handleDetalles(prueba)}>
                            <td>{ prueba.fechaFormato }</td>
                            <td>{ prueba.tipoPrueba }</td>
                            <td>{ prueba.prueba }</td>
                            <td>{ prueba.alergenos.map(alerg => alerg.nombre).join(', ') }</td>
                            <td><div className={styles.centeredBadgeContainer}><span className="badge" style={{backgroundColor: (prueba.positiva) ? colors.SUCCESS : colors.DANGER}}>{ (prueba.positiva) ? 'Positivas' : 'Negativas' }</span></div></td>
                            <td>
                              <IconButton
                                icon='ChevronRight'
                                iconColor='#666666'
                                marginTop={false}
                                onClick={() => handleDetalles(prueba)}
                                type='button'
                              />
                            </td>
                          </tr>) }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  {(statusDetallesModal) &&
                    <ModalContainer
                      state={ statusDetallesModal }
                      hide={ hideDetallesModal }
                      content={ <DetallePruebaAlergiaModal hide={ hideDetallesModal } data={(pruebaAlergiaActiva !== null) ? pruebaAlergiaActiva : {}} /> }
                    />
                  }
                </>
                : <Empty />
              }
            </>
          }
        </>
    }
    </>
  ) : <div className='mt-2'><Forbidden /></div>
}
